import { apiService } from './api';
import {
  MySubscription,
  Subscription,
  SubscriptionCreateRequest,
  SubscriptionPlan,
  SubscriptionPlanCreateRequest,
  SubscriptionPlanPublic,
  SubscriptionUpdateRequest,
  SubscriptionUsage,
} from '../types/subscription.types';

const BASE = '/subscriptions';

export const subscriptionService = {
  // ---- Plans (admin) ----
  getPlans: (params?: { page?: number; page_size?: number }) =>
    apiService.get<{ count: number; results: SubscriptionPlan[] }>(`${BASE}/plans/`, params),

  getPlan: (id: string) =>
    apiService.get<SubscriptionPlan>(`${BASE}/plans/${id}/`),

  createPlan: (data: SubscriptionPlanCreateRequest) =>
    apiService.post<SubscriptionPlan>(`${BASE}/plans/`, data),

  updatePlan: (id: string, data: Partial<SubscriptionPlanCreateRequest>) =>
    apiService.patch<SubscriptionPlan>(`${BASE}/plans/${id}/`, data),

  deletePlan: (id: string) =>
    apiService.delete<void>(`${BASE}/plans/${id}/`),

  getPublicPlans: () =>
    apiService.get<SubscriptionPlanPublic[]>(`${BASE}/plans/public/`),

  // ---- Subscriptions (admin) ----
  getSubscriptions: (params?: { search?: string; status?: string }) =>
    apiService.get<{ count: number; results: Subscription[] }>(`${BASE}/`, params),

  getSubscription: (id: string) =>
    apiService.get<Subscription>(`${BASE}/${id}/`),

  createSubscription: (data: SubscriptionCreateRequest) =>
    apiService.post<Subscription>(`${BASE}/`, data),

  updateSubscription: (id: string, data: SubscriptionUpdateRequest) =>
    apiService.patch<Subscription>(`${BASE}/${id}/`, data),

  deleteSubscription: (id: string) =>
    apiService.delete<void>(`${BASE}/${id}/`),

  // ---- Tenant-facing ----
  getMySubscription: () =>
    apiService.get<MySubscription>(`${BASE}/my/`),

  createCheckoutSession: (planId: string, successUrl?: string, cancelUrl?: string) =>
    apiService.post<{ checkout_url: string }>(`${BASE}/checkout/`, {
      plan_id: planId,
      success_url: successUrl,
      cancel_url: cancelUrl,
    }),

  createPortalSession: (returnUrl?: string) =>
    apiService.post<{ portal_url: string }>(`${BASE}/portal/`, {
      return_url: returnUrl,
    }),

  verifyCheckout: (sessionId: string) =>
    apiService.post<MySubscription>(`${BASE}/verify-checkout/`, { session_id: sessionId }),

  getUsage: () =>
    apiService.get<SubscriptionUsage>(`${BASE}/usage/`),
};
